<template>
  <div class="product-grid-item" v-if="product" @mouseover="setControl(true)" @mouseleave="setControl(false)" @mousedown="onMouseDown" @mousemove="onMouseMove" @mouseup="onMouseUp" @click.stop="onClick">
    <div class="position-relative overflow-hidden">
      <div class="image" :style="util.getImageStyle(product.goodsImg)"></div>
      <div class="image hover-image position-absolute" :style="util.getImageStyle(product.goodsImg2)" v-if="product.goodsImg2"></div>
      <div  class="position-absolute top-0 start-0 d-flex">
        <tag-promote class="tag" v-if="util.isPromoteProduct(product) && product.promotePrice"/>
        <template  v-else-if="shopDiscount">
          <tag-user-rank-discount class="tag" v-if="userRank && (shopVipDiscount === 1 || (shopVipDiscount === 2 && product.isMemberDiscount))"/>
          <tag-discount class="tag" v-else :discount="shopDiscount"/>
        </template>
        <!--tag-user-rank class="tag" v-else-if="userRank && userRank.discount && userRank.discount < 100"/-->
        <tag-new class="tag" v-else-if="isNewProduct"/>
      </div>
      <!-- <small class="color-label position-absolute">+color</small> -->
    </div>
    <div class="d-none d-md-block" :class="view.showControl ? 'visible' : 'invisible'">
      <div class="btn-group w-100" role="group">
        <button class="btn btn-product-option p-1" data-bs-toggle="modal" data-bs-target="#product-modal" @click.stop="setSelectedProduct(product)">加入購物車</button>
        <button class="btn btn-product-option p-1">顯示更多</button>
      </div>
    </div>
    <div class="info mt-md-0 mt-2">
      <div class="name">{{ product.goodsName }}</div>
      <div class="brand">{{ getBrandName(product.brandId) }}</div>
      <div v-if="util.hasCheaperPrice(product, userRank)">
        <span class="price-orig text-secondary text-decoration-line-through" v-show="product.shopPrice !== constant.PRODUCT_PRICE_ASK">{{ util.toPriceFormat(product.marketPrice) }}</span>
        <span class="price loft-text-highlight" v-if="product.shopPrice === constant.PRODUCT_PRICE_ASK">價格電洽</span>
        <span class="price loft-text-highlight" v-else>{{ util.toPriceFormat(util.getGoodsPrice(product, userRank, shopVipDiscount, 0)) }}</span>
      </div>
      <div class="price" v-else>{{ util.toPriceFormat(product.marketPrice) }}</div>
    </div>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import { mapGetters, mapMutations } from 'vuex'
import TagDiscount from './TagDiscount.vue'
import TagNew from './TagNew.vue'
import TagPromote from './TagPromote.vue'
// import TagUserRank from './TagUserRank.vue'
import TagUserRankDiscount from './TagUserRankDiscount.vue'

export default {
  name: 'ProductGridItem',
  components: {
    TagDiscount,
    TagNew,
    TagPromote,
    // TagUserRank,
    TagUserRankDiscount
  },
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      view: {
        showControl: false
      },
      mouse: {
        active: false,
        isMoving: false,
        start: { x: 0, y: 0 },
        end: { x: 0, y: 0 }
      }
    }
  },
  computed: {
    ...mapGetters([
      'getBrandName',
      'userRank',
      'shopVipDiscount'
    ]),
    constant: function () {
      return constant
    },
    util: function () {
      return util
    },
    shopDiscount: function () {
      var ret = util.getProductDiscount(this.product)
      if (ret && this.userRank && this.userRank.discount && this.userRank.discount < 100) {
        if (!(this.shopVipDiscount === 1 || (this.shopVipDiscount === 2 && this.product.isMemberDiscount)) && (100 - this.userRank.discount) > ret) {
          return null
        }
      }
      return ret
    },
    isNewProduct: function () {
      var lastMonth = new Date()
      lastMonth.setMilliseconds(0)
      lastMonth.setSeconds(0)
      lastMonth.setMinutes(0)
      lastMonth.setHours(0)
      lastMonth.setMonth(lastMonth.getMonth() - 1)
      return this.product && this.product.onSaleDate && this.product.onSaleDate >= parseInt(lastMonth.getTime() / 1000)
    }
  },
  methods: {
    ...mapMutations([
      'setSelectedProduct'
    ]),
    setControl: function (value) {
      // do not show control if require for asking price
      if (this.product.shopPrice === constant.PRODUCT_PRICE_ASK) {
        return
      }
      this.view.showControl = value
      if (!value) {
        this.mouse.active = false
      }
    },
    onMouseDown: function (event) {
      this.mouse.isMoving = false
      this.mouse.active = true
      this.mouse.start.x = event.clientX
      this.mouse.start.y = event.clientY
    },
    onMouseUp: function (event) {
      this.mouse.active = false
      this.mouse.end.x = event.clientX
      this.mouse.end.y = event.clientY
    },
    onMouseMove: function (event) {
      if (!this.mouse.active) {
        return
      }
      this.mouse.isMoving = true
    },
    onClick: function (event) {
      if (this.mouse.isMoving) {
        var dx = Math.abs(this.mouse.end.x - this.mouse.start.x)
        var dy = Math.abs(this.mouse.end.y - this.mouse.start.y)
        if (dx > 10 || dy > 10) {
          return
        }
      }
      this.$router.push(`/w/product/detail/${this.product.goodsId}`)
    }
  }
}
</script>

<style scoped>
.product-grid-item {
  cursor: pointer;
}
.image {
  width: 100%;
  padding-bottom: 100%;  /* 以父層寬度撐出 1:1 正方形，寬度固定高度才會一致 */
}
.hover-image {
  top: 0;
  opacity: 0;
  transform: scale(1.1);
  transition: all .5s cubic-bezier(.25,1,.5,1);
  transition-delay: 0ms, 0ms;
}
.hover-image:hover {
  opacity: 1;
  transform: scale(1);
}
.tag {
  margin: 12px 0 0 12px;
}
.color-label {
  bottom: 4px;
  left: 8px;
  font-family: 'Noto Serif TC', serif;
}
.brand {
  font-family: 'Noto Serif TC', serif;
  font-size: 1rem;
  /* 品牌名固定一行，過長以省略號收尾，避免把下方價格往下推 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.name {
  font-size: 1rem;
  line-height: 1.5;
  /* 商品名稱固定一行，過長自動截斷加省略號。
     項目寬度已固定，nowrap 不會再把格子撐寬，超出的部分才會被 ellipsis 收掉 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.price-orig {
  font-size: 0.6rem;
}
.price {
  font-size: 1.1rem;
}
.btn-product-option {
  font-size: 0.6rem;
  background-color: var(--bg-color);
  border-color: lightgray;
  border-width: 1px;
  margin-bottom: 2px;
  width: 50%;
}
.btn-product-option:hover {
  border-color: var(--bs-dark);
  border-width: 2px;
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .name {
    font-size: 1.5rem;
  }
  .brand {
    font-size: 1.5rem;
  }
  .price {
    font-size: 1.3rem;
  }
}
</style>
